import { fg } from '@confluence/feature-gating';
import { expVal } from '@confluence/feature-experiments';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import {
	AccessStatus,
	ConfluenceEdition,
} from '@confluence/session-data/entry-points/SiteInformationQuery.ts';

export type CwrSplitButtonCohort = 'control' | 'variant_1' | 'variant_2' | 'not-enrolled';

export function useCwrSplitButtonExperiment(): {
	cohort: CwrSplitButtonCohort;
	isEnabled: boolean;
} {
	const { accessStatus, edition, isLoggedIn } = useSessionData();

	const isAnonymousUser = accessStatus === AccessStatus.ANONYMOUS_ACCESS || !isLoggedIn;
	const isStandardUser = edition === ConfluenceEdition.STANDARD;

	// Internal release gate: when enabled, force the split button experience on
	// for internal (fishfooding) users and early-return so we don't need to run
	// the rest of the experiment exposure code (`expVal`) below. Anonymous users
	// are never eligible, so we only short-circuit for logged-in users.
	if (!isAnonymousUser && fg('navx_uc_cwr_split_button_internal_release')) {
		return { cohort: 'variant_2', isEnabled: true };
	}

	const cohort: CwrSplitButtonCohort =
		isStandardUser && !isAnonymousUser
			? (expVal(
					'navx_universal_create_cwr_split_button',
					'cohort',
					'control',
				) as CwrSplitButtonCohort)
			: 'not-enrolled';

	const isEnabled = cohort === 'variant_1' || cohort === 'variant_2';

	return { cohort, isEnabled };
}
